// Matches a product's admin-typed printMethod free-text value against the
// set of real-world labels vendors/admins have used for doming, so the
// doming-preview module (services/domingPreviewService.ts) can recognize a
// design that should get the real domed-resin-lens preview. Mirrors
// embossingPreview.ts's own EMBOSSING_METHOD_KEYWORDS matching convention
// exactly (see that file's comment for the full rationale on why a
// substring match, not an enum).
//
// Confirmed against real seeded ProductConfig.printMethods data (30 rows,
// e.g. AR1589/IT2386) and translationLookup.ts's own EN->NL mapping (which
// maps "Doming" to itself, line ~157) — there is no separate Dutch term the
// way "Blinddruk" is for embossing; vendors/Magento consistently use the
// literal English word "Doming" in both languages.
const DOMING_METHOD_KEYWORDS = ['dome', 'doming'];

export function isDomingPrintMethod(printMethod: string | null | undefined): boolean {
  if (!printMethod) return false;
  const lower = printMethod.toLowerCase();
  return DOMING_METHOD_KEYWORDS.some(kw => lower.includes(kw));
}

export const DOMING_PREVIEW_DESIGN_IMAGE_TYPE = 'doming_preview';

// Design.domingPreviewStatus int convention — mirrors EmbossingPreviewStatus
// (see schema.prisma's own comment on the column).
export const DomingPreviewStatus = {
  NONE:       0,
  QUEUED:     1,
  PROCESSING: 2,
  DONE:       3,
  FAILED:     4,
} as const;
export type DomingPreviewStatusValue = typeof DomingPreviewStatus[keyof typeof DomingPreviewStatus];
